import update from 'immutability-helper'

import * as actions from '../../actions/actions'

const initialState = {
    contoCorrenteToEdit: {
        note: '',
        contoCorrente: '',
        senderAccount: '',
        corporate: {}
    },
    error: ''
}

export default function contoCorrenteEdit(state = initialState, action) {
    switch (action.type) {
        case actions.FETCH_CONTO_CORRENTE_EDIT_SUCCESS:
            return fetchContoCorrenteEditSuccess(state, action)
        case actions.FETCH_CONTO_CORRENTE_EDIT_FAILURE:
            return fetchContoCorrenteEditFailure(state, action)
        case actions.EDIT_CONTO_CORRENTE_NOTE_FILED_CHANGE:
            return editContoCorrenteNoteFiledChange(state, action)
        case actions.EDIT_CONTO_CORRENTE_CONTO_CORRENTE_FILED_CHANGE:
            return editContoCorrenteContoCorrenteFiledChange(state, action)
        case actions.EDIT_CONTO_CORRENTE_SENDER_ACCOUNT_FILED_CHANGE:
            return editContoCorrenteSenderAccountFiledChange(state, action)
        case actions.EDIT_CONTO_CORRENTE_CLEAN:
            return editContoCorrenteClean(state, action)
        case actions.UPDATE_CONTO_CORRENTE_EDIT_FAILURE:
            return updateContoCorrenteFailure(state,action)
        default:
            return state
    }
}

const updateContoCorrenteFailure = (state, action) => {
    return {
        ...state,
        error: action.error
    }
}

const fetchContoCorrenteEditSuccess = (state, action) => {
    return {
        ...state,
        contoCorrenteToEdit: action.value
    }
}

const fetchContoCorrenteEditFailure = (state, action) => {
    return {
        ...state,
        error: action.error
    }
}

const editContoCorrenteNoteFiledChange = (state, action) => {
    return update(
        state,
        {contoCorrenteToEdit: {note: {$set: action.value}}}
    )
}

const editContoCorrenteContoCorrenteFiledChange = (state, action) => {
    return update(
        state,
        {contoCorrenteToEdit: {contoCorrente: {$set: action.value}}}
    )
}

const editContoCorrenteSenderAccountFiledChange = (state, action) => {
    return update(
        state,
        {contoCorrenteToEdit: {senderAccount: {$set: action.value}}}
    )
}

const editContoCorrenteClean = (state, action) => {
    return initialState;
}